
import { Variavel } from '@/dominio/formulario/questoes/Variavel';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'VariavelComponent',
    props: {
        variavel: {
            type: Variavel,
            required: true,
        },
        valor: {
            type: String,
            required: true,
        },
    },
    emits: ['update:valor'],
    setup(props, { emit }) {
        const updateValor = (e: Event) => {
            emit('update:valor', (e.target as HTMLInputElement).value);
        };
        return { updateValor };
    },
});
